import { ICategory } from "web/types/Category";
import { Nullable } from "web/types/Utils";

const getParentCategoryById = (
  categories: ICategory[],
  parentCategoryId: Nullable<number>
) =>
  parentCategoryId
    ? categories?.find(
        (category) => category && `${category.id}` === `${parentCategoryId}`
      )
    : null;

export default getParentCategoryById;
